import React from "react";
import { Box } from "fds";
import classNames from "classnames";
import "./index.scss";
interface RevisionTagProps {
  revisionNo?: number;
  size?: "sm" | "md";
  classes?: string;
}
const RevisionTag: React.FC<RevisionTagProps> = ({
  revisionNo,
  size = "sm",
  classes,
}) => {
  return (
    <Box classes={classNames("revisionTag", size, classes)}>
      v{revisionNo ?? 0}
    </Box>
  );
};
export default RevisionTag;
